function formatMoney(cents) {
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    maximumFractionDigits: 0
  }).format(cents / 100);
}

window.PackSize = {

  renderPackCards(selectedVariant) {
    FBT.setCurrentVariant(selectedVariant);
    const container = document.querySelector(".pack-size-cards");

    if (!container) return;
    container.innerHTML = "";

    const selectedColor = selectedVariant.option1;

    // Sirf selected color ke variants lo
    const colorVariants = window.variants.filter(
      variant => variant.option1 === selectedColor
    );

    colorVariants.forEach((variant, index) => {
      const isActive = variant.id == selectedVariant.id;

      // Ab index har color ke liye 0,1,2... hoga
      const offer = this.getOffer(index);

      container.insertAdjacentHTML(
        "beforeend",
        `
        <div
          class="pack-size-card ${isActive ? "active" : ""}"
          data-variant-id="${variant.id}"
          data-offer-index="${index}"
        >
          ${this.renderBadge(offer)}

          <div class="pack-size-card-top">

            <div class="pack-size-radio">
              ${isActive ? "<span></span>" : ""}
            </div>

            <div class="pack-size-content">

              <div class="pack-size-title-row">
                <h4>${variant.option2 || variant.title}</h4>

                ${this.renderPercentageBadge(offer)}
              </div>

              ${this.renderPackSizeMessage(offer)}

              ${this.renderPerTube(variant)}

              ${this.renderMessage(offer)}

            </div>

            ${this.renderVariantPrice(variant)}

          </div>

          ${isActive ? this.renderOffer(offer) : ""}

        </div>
        `
      );
    });

    this.syncOfferVariant(selectedVariant);
    this.bindPackCardEvents();
  },

  bindPackCardEvents() {
    document.querySelectorAll(".pack-size-card").forEach(card => {
      card.addEventListener("click", () => {
        console.log(card, 'cardData');
        const variantId = card.dataset.variantId;
        const variantInput = document.querySelector('[name="id"]');

        if (!variantInput) return;

        variantInput.value = variantId;

        // Set offer variant
        const offerInput = document.querySelector("#offer_variant_id");

        if (offerInput) {
          const variantIndex = Number(card.dataset.offerIndex);
          const offer = this.getOffer(variantIndex);
          
          if (offer?.active && offer?.product?.variantId) {
            offerInput.value = offer.product.variantId;
          } else {
            offerInput.value = "";
            console.log("No active offer");
          }
        }

        variantInput.dispatchEvent(
          new Event("change", {
            bubbles: true
          })
        );

        const newVariant = window.variants.find(
          v => v.id == variantId
        );

        if (!newVariant) return;
        history.replaceState(null, "", `?variant=${newVariant.id}`);
        FBT.setCurrentVariant(newVariant);
        setTimeout(() => {
          this.renderPackCards(newVariant);
        }, 100);
      });
    });

    document.querySelectorAll(".pack-size-offer-checkbox").forEach((checkbox) => {
      checkbox.addEventListener("click", (e) => {
        e.stopPropagation();

        const index = Number(checkbox.dataset.offerIndex);
        const offer = this.getOffer(index);

        if (!offer) return;

        offer.active = !offer.active;
        checkbox.classList.toggle("active", offer.active);

        // Click par offer_variant_id input ko Sync karna
        const offerInput = document.querySelector("#offer_variant_id");
        if (offerInput) {
          if (offer.active && offer?.product?.variantId) {
            offerInput.value = offer.product.variantId;
          } else {
            offerInput.value = "";
          }
        }
      });
    });
  },

  getOffer(index) {
    return window.packOffers?.find(
      offer => Number(offer.cardIndex) === index
    );
  },

  syncOfferVariant(selectedVariant) {
    const offerInput = document.querySelector("#offer_variant_id");

    if (!offerInput) return;

    const selectedColor = selectedVariant.option1;

    const colorVariants = window.variants.filter(
      variant => variant.option1 === selectedColor
    );

    const variantIndex = colorVariants.findIndex(
      variant => Number(variant.id) === Number(selectedVariant.id)
    );

    if (variantIndex === -1) {
      offerInput.value = "";
      return;
    }

    const offer = this.getOffer(variantIndex);

    // active === true hone par hi variantId pass hogi
    if (
      offer &&
      offer.active === true &&
      offer?.product?.variantId
    ) {
      offerInput.value = offer.product.variantId;

      console.log(
        "INITIAL OFFER VARIANT SET:",
        offer.product.variantId
      );
    } else {
      offerInput.value = "";

      console.log(
        "NO ACTIVE OFFER"
      );
    }
  },

  renderBadge(offer) {
    if (!offer) return "";

    let html = "";

    if (offer.badge) {
      html += `
        <div class="pack-size-badge">
          ${offer.badge}
        </div>
      `;
    }

    return html;
  },

  renderPercentageBadge(offer) {
    if (!offer?.percentageOffBadge) return "";

    return `
      <span class="pack-size-percentage-badge">
        ${offer.percentageOffBadge}
      </span>
    `;
  },

  renderPerTube(variant) {
    if (!variant.metafields?.custom?.quantity) return "";

    return `
      <p class="pack-size-per-tube">
        ${formatMoney(
          variant.price / variant.metafields.custom.quantity
        )} per tube
      </p>
    `;
  },

  renderMessage(offer) {
    if (!offer?.message) return "";

    if (offer.product?.image) return "";

    return `
      <p class="pack-size-gift-text">
        ${offer.message}
      </p>
    `;
  },

  renderPackSizeMessage(offer) {
    console.log(offer, 'this is pack');
    if (!offer?.packSizeMessage) return "";

    return `
      <p class="pack-size-message">
        ${offer.packSizeMessage}
      </p>
    `;
  },

  renderVariantPrice(variant) {
    return `
      <div class="pack-size-price">

        <div class="pack-size-sale-price">
          ${formatMoney(variant.price)}
        </div>

        ${
          variant.compare_at_price > variant.price
          ? `
          <div class="pack-size-compare-price">
            ${formatMoney(variant.compare_at_price)}
          </div>
          `
          : ""
        }

      </div>
    `;
  },

  renderOffer(offer) {
    if (!offer?.product?.image) return "";

    return `
      <div
        class="pack-size-offer"
        data-product-id="${offer.product.id}"
        data-card-index="${offer.cardIndex}"
      >
        ${
          offer.showCheckbox
          ? `
          <div
            class="pack-size-offer-checkbox ${offer.active ? "active" : ""}"
            data-offer-index="${offer.cardIndex}"
          ></div>
          `
          : ""
        }

        <img
          class="pack-size-offer-image"
          src="${offer.product.image}"
          alt=""
        >

        <div class="pack-size-offer-content">

          <div class="pack-size-offer-title">
            ${offer.message || offer.product.title}
          </div>

        </div>

      ${
        (offer.offerPrice || offer.comparePrice)
        ? `
        <div class="pack-size-offer-prices">

         <div class="pack-size-offer-price">
            ${
              offer.offerPrice
              ? `₹${Number(offer.offerPrice).toLocaleString("en-IN")}`
              : "FREE"
            }
          </div>

          ${
            offer.comparePrice
            ? `<div class="pack-size-offer-compare">₹${Number(offer.comparePrice).toLocaleString("en-IN")}</div>`
            : ""
          }

        </div>
        `
        : ""
      }

      </div>
    `;
  }

};

document.addEventListener("click", function (e) {
  const button = e.target.closest('[data-add-to-cart]');

  if (!button) return;

  const productForm = button.closest(
    ".product-single__form, form[action*='/cart/add']"
  );
  console.log(productForm, 'productForm');
  if (!productForm) return;

  const offerInput = productForm.querySelector("#offer_variant_id");

  if (!offerInput) return;

  const offerVariantId = offerInput.value;

  if (!offerVariantId) return;

  e.preventDefault();
  e.stopImmediatePropagation();

  const variantInput = productForm.querySelector('[name="id"]');

  if (!variantInput) return;

  const mainVariantId = variantInput.value;

  console.log("FBT ADD:", {
    mainVariantId,
    offerVariantId
  });

  theme.addMultipleProductsToCart([
    {
      id: mainVariantId,
      quantity: 1
    },
    {
      id: offerVariantId,
      quantity: 1
    }
  ]);

}, true);